<script setup>
import Logo from 'assets/logos/logo.svg?url'

const { t } = useI18n()
</script>

<template>
    <NuxtLinkLocale :to="{ name: 'index' }" class="page-default-layout logo-link" :title="t('logo_title')">
        <img
            :src="Logo" :alt="t('logo_title')" :aria-label="t('logo_title')" width="285"
            height="147"
        >
    </NuxtLinkLocale>
</template>

<style lang="scss">
.logo-link {
    width: px2rem(95);
    text-decoration: none;
    display: flex;
    align-items: center;

    @include bp(medium1) {
        width: px2rem(120);
    }

    @include bp(large2) {
        width: px2rem(165);
    }

    > img {
        width: 100%;
        height: auto;
    }
}
</style>
